import { toPlatePlugin } from '@udecode/plate/react';

import { BaseSourceCaptionPlugin } from '../lib';

/** Enables support for tables with React-specific features. */
export const SourceCaptionPlugin = toPlatePlugin(BaseSourceCaptionPlugin);
